import React, { forwardRef } from 'react';

/**
 * Componente de input estilizado e reutilizável
 */
const Input = forwardRef(({ 
  type = 'text', 
  className = '', 
  error,
  inputMode,
  ...props 
}, ref) => {
  // Determinar o inputmode baseado no tipo de input se não foi fornecido explicitamente
  const getInputMode = () => {
    if (inputMode) return inputMode;
    
    switch (type) {
      case 'number':
        return 'decimal';
      case 'tel':
        return 'numeric';
      case 'email':
        return 'email';
      case 'url':
        return 'url';
      default:
        return undefined;
    }
  };

  return (
    <div>
      <input
        ref={ref}
        type={type}
        inputMode={getInputMode()}
        className={`
          w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500
          ${error ? 'border-red-500' : 'border-gray-300'}
          ${className}
        `}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input; 